import React, { Children } from "react";
import MtiButton from "../Buttons/MtiButton";
import Modal from "./Modal";
import "./ModalNotification.css";
import { ENotificationType } from "../../Model/ENotificationType";
import IconSuccess from "../../Icons/ModalNotification/Success";
import IconWarning from "../../Icons/ModalNotification/Warning";
import IconError from "../../Icons/ModalNotification/Error";

type Props = {
  headerText: string;
  bodyTitleText: string;
  bodySubTitleText: string;
  type: ENotificationType;
  show: boolean;
  onHide: (show: boolean) => void;
  onClickOk?: () => void;
  onClickCancel?: () => void;
  okButtonDisabled?: boolean;
  okLabel?: string;
  cancelLabel?: string;
};

export default function ModalNotificationView({
  headerText,
  bodyTitleText,
  bodySubTitleText,
  type,
  show,
  onHide,
  onClickOk,
  onClickCancel,
  okButtonDisabled,
  okLabel,
  cancelLabel,
}: Props) {
  let icon = null;
  switch (type) {
    case ENotificationType.Info:
      throw new Error("Icon info is not found");
      break;
    case ENotificationType.Warning:
      icon = <IconWarning />;
      break;
    case ENotificationType.Error:
      icon = <IconError />;
      break;
    case ENotificationType.Success:
      icon = <IconSuccess />;
      break;
  }

  const onHideAction = () => {
    onHide(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHideAction}
      hideOnBackdropClick={false}
      className="modal-notification"
    >
      <Modal.Header
        title={headerText}
        hideButtonEnabled={false}
        className="modal-notification-header"
      />
      <Modal.Body className="modal-notification-body">
        {icon}
        <div className="modal-notification-title">
          <p>{bodyTitleText}</p>
        </div>
        <div className="modal-notification-subtittle">{bodySubTitleText}</div>
      </Modal.Body>
      <Modal.Footer
        className="modal-notification-footer"
        onClickOk={onClickOk}
        onClickCancel={onClickCancel}
        okButtonDisabled={okButtonDisabled}
        okLabel={okLabel}
        cancelLabel={cancelLabel}
      />
    </Modal>
  );
}
